import amplitude from 'amplitude-js'
import { AMPLITUDE_KEY, PAYMENT_GATEWAY_PROPERTY } from '@constants'
import { safeStorageGet } from '@utils'

let paymentGateway: string | null = null

export const initAmplitude = (userId: string | undefined, callback: (key: string) => void) => {
  if (!AMPLITUDE_KEY) return
  amplitude.getInstance().init(AMPLITUDE_KEY, userId, {}, () => callback('amplitude'))
}

export const setAmplitudeUserId = (userId: string) => amplitude.getInstance().setUserId(userId)

export const sendAmplitudeData = (eventType: string, eventParams: object) => {
  const params = { ...eventParams } as Record<string, unknown>
  // Amplitude-only: BI, Google Tag and backend keep receiving stripe_account_name.
  delete params.stripe_account_name
  if (paymentGateway) params[PAYMENT_GATEWAY_PROPERTY] = paymentGateway

  const checkInit = setInterval(() => {
    if (safeStorageGet('amplitudeInit') === 'true') {
      amplitude.getInstance().logEvent(eventType, params)
      clearInterval(checkInit)
    }
  }, 500)
}

export const setAmplitudeUserProperties = (properties: object) => {
  if (!AMPLITUDE_KEY) return
  amplitude.getInstance().setUserProperties(properties)
}
export const trackPaymentGateway = (gateway: string) => {
  paymentGateway = gateway
  setAmplitudeUserProperties({ [PAYMENT_GATEWAY_PROPERTY]: gateway })
  return gateway
}
